import { MemberPortalSharedState } from './../../store/shared.states';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey } from '../../store/shared.reducers';

import { IPersonalContributionEditState } from './state';

export const memberPortalState = createFeatureSelector<MemberPortalSharedState>(featureKey);

export const editMember = createSelector(memberPortalState, (state) => state.personalContributionEditState);

export const editMember_Form = createSelector(
  editMember,
  (state: IPersonalContributionEditState) => state.form
);

export const editMember_LastModified = createSelector(
  editMember,
  (state: IPersonalContributionEditState) => state.lastModifiedTime
);

export const editMember_BankDetails = createSelector(
  editMember,
  (state: IPersonalContributionEditState) => state.bankDetails
);
